import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SidebarButtonBadge.module.scss';
import cx from 'classnames';

const SidebarButtonBadge = ({ variant = 'primary', pulse, className, text }) => {
    const { t } = useTranslation();

    const badgeText = text || t('general.new');

    return <div className={cx(styles.badge, styles[variant], { [styles.pulse]: pulse }, className)}>{badgeText}</div>;
};

export default SidebarButtonBadge; 